import { StrictMode, useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { AuthCtx, AuthUser } from './lib/auth';

function Root() {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem('mw_token'));
  const [user, setUser]   = useState<AuthUser | null>(() => {
    try { return JSON.parse(localStorage.getItem('mw_user') ?? 'null'); } catch { return null; }
  });

  const login = (t: string, u: AuthUser) => {
    localStorage.setItem('mw_token', t);
    localStorage.setItem('mw_user', JSON.stringify(u));
    setToken(t); setUser(u);
  };

  const logout = () => {
    localStorage.removeItem('mw_token');
    localStorage.removeItem('mw_user');
    setToken(null); setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, token, login, logout, isAdmin: user?.role === 'admin' }}>
      <App />
    </AuthCtx.Provider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode><Root /></StrictMode>
);
